export default {
  baseUrl: "/api",
};
